import { render, staticRenderFns } from "./TabBar2.vue?vue&type=template&id=2db8e233&scoped=true"
import script from "./TabBar2.vue?vue&type=script&lang=js"
export * from "./TabBar2.vue?vue&type=script&lang=js"
import style0 from "./TabBar2.vue?vue&type=style&index=0&id=2db8e233&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db8e233",
  null
  
)

export default component.exports